// Consultar, programar, comprometer, adjuntar y completar un pago solo
// requieren acceso a Aprobaciones o Seguimiento Financiero.
export const TREASURY_PERMISSION_PAGES=[
  {ruta:'pagos/tesoreria/planes/modificar',nombre:'Modificar programación y referencia'},
];
